import { render, staticRenderFns } from "./Pooter.vue?vue&type=template&id=4fcee730&scoped=true&"
import script from "./Pooter.vue?vue&type=script&lang=js&"
export * from "./Pooter.vue?vue&type=script&lang=js&"
import style0 from "./Pooter.vue?vue&type=style&index=0&id=4fcee730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcee730",
  null
  
)

export default component.exports